// extracted by mini-css-extract-plugin
module.exports = {"map":"ObjectsMap_map__BUf_Z","loading":"ObjectsMap_loading__DSNGX"};